import { db, FirebaseDocRefType, FirebaseDocumentDataType, FirebaseSnapshotType } from 'firebase/index'
import { ShopSubscriptionType } from 'types/shopSubscription'

const queryShopSubscriptions = (storeRef: FirebaseDocRefType): Promise<ShopSubscriptionType[]> => {
  return db
    .collection('shop_subscriptions')
    .where('store_ref', '==', storeRef)
    .get()
    .then((snapshots: FirebaseDocumentDataType) => {
      const shopSubscriptions: ShopSubscriptionType[] = []
      snapshots.forEach((snapshot: FirebaseSnapshotType) => {
        const data = snapshot.data() as ShopSubscriptionType
        shopSubscriptions.push(data)
      })
      return shopSubscriptions
    })
    .catch((error: unknown) => {
      console.error(error)
      return []
    })
}

export default queryShopSubscriptions
